import { connect } from 'react-redux'
import HeaderAppendProxy from 'components/layout/HeaderAppendProxy'

const mapStateToProps = state => ({
  controller: state.layout.controller,
  pageParameters: state.page.configParameters
})

export default connect(mapStateToProps, null)(HeaderAppendProxy)
